import { render, staticRenderFns } from "./PollsFilter.vue?vue&type=template&id=72b3d62a"
import script from "./PollsFilter.vue?vue&type=script&lang=js"
export * from "./PollsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports